const StatusLabel = ({ label, status }) => {
  let className =
    "inline-block w-fit px-5 py-1 text-sm capitalize rounded-[10px] text-base font-bold";
  if (status === "supervisor" || status === "admin" || status === "disabled")
    className += " bg-red-100 dark:bg-red-50 text-red-500";
  else if (status === "member")
    className += " bg-gray-100 dark:bg-gray-900 dark:text-white text-gray-800";
  else
    className +=
      " bg-green-100 text-green-700 dark:bg-green-200 dark:text-green-800";

  return <div className={className}>{label || status}</div>;
};

export default StatusLabel;
